"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getFeature = getFeature;
exports.getUrlWithoutFeature = getUrlWithoutFeature;
exports.isAllowedRedirectHost = isAllowedRedirectHost;
exports.normalizeHostname = normalizeHostname;
exports.replaceFeature = replaceFeature;
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isObjectLike2 = _interopRequireDefault(require("lodash/isObjectLike"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _replace2 = _interopRequireDefault(require("lodash/replace"));
var _endsWith2 = _interopRequireDefault(require("lodash/endsWith"));
/* eslint-disable */

const hostRegex = /(?:([A-Za-z0-9-]+)\.)(([a-zA-Z0-9-]+)[.]([a-zA-Z0-9-]+)\.onereach\.ai)/;
const portRegex = /^(https?:\/\/)/;
const featureRegex = /\/FEATURE./;
function getFeature(url) {
  const hostMatch = hostRegex.exec(url) || [];
  return hostMatch[1] || 'master';
}
function getUrlWithoutFeature(url, feature) {
  return (0, _replace2.default)(url, `/${feature}.`, '/');
}
function replaceFeature(obj, feature) {
  (0, _forEach2.default)((0, _keys2.default)(obj), key => {
    if ((0, _isString2.default)(obj[key])) {
      obj[key] = (0, _replace2.default)(obj[key], featureRegex, `/${feature === 'master' ? '' : `${feature}.`}`);
    } else if ((0, _isObjectLike2.default)(obj[key])) {
      replaceFeature(obj[key], feature);
    }
  });
}
function normalizeHostname(value) {
  if (!(0, _isString2.default)(value) || !value) return '';
  if (value.includes('://')) {
    return new URL(value).hostname.toLowerCase();
  }
  return (0, _replace2.default)(value, /:\d+$/, '').toLowerCase();
}
function isAllowedRedirectHost(currentHostname, legalHost, allowedHosts = []) {
  const normalizedCurrentHost = normalizeHostname(currentHostname);
  const normalizedLegalHost = normalizeHostname(legalHost);
  const normalizedAllowedHosts = Array.isArray(allowedHosts) ? allowedHosts.filter(value => (0, _isString2.default)(value) && Boolean(value)).map(normalizeHostname).filter(Boolean) : [];
  return normalizedCurrentHost === normalizedLegalHost || (0, _endsWith2.default)(normalizedCurrentHost, `.${normalizedLegalHost}`) || normalizedAllowedHosts.includes(normalizedCurrentHost);
}
var _default = (config, runningProjects, localOverrides, shouldRedirect = true, feature, allowedHosts) => {
  config.LOCAL = process.env.NODE_ENV === "development";
  if (config.LOCAL) {
    (0, _merge2.default)(config, runningProjects, localOverrides);
  }
  const legalHost = `${config.service}${config.CLIENT_DOMAIN}`;
  const resolvedAllowedHosts = typeof allowedHosts === 'function' ? allowedHosts(config) : allowedHosts;
  if (shouldRedirect && !config.LOCAL && config.FEATURES_ENABLED && !isAllowedRedirectHost(document.location.hostname, legalHost, resolvedAllowedHosts)) {
    window.location = `${window.location.protocol}//${legalHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
    throw new Error("Prevent window from further location changes");
  }
  config.FEATURE = feature || getFeature(document.location.hostname);
  replaceFeature(config, config.FEATURE);
  return config;
};
exports.default = _default;